

import gif from "../../images/glowgif01.gif";

import e from "../../images/e.png";


import bgImage2 from "../../images/glow.png";
import heroImg from "../../images/Hero.png";
import train from "../../images/training01.png";
import staff from "../../images/staff1.png";
import deveop from "../../images/deveop.png";
import walmart from "../../images/walmart.png";
import jpmc from "../../images/jpchase.png";
import fmac from "../../images/fmac.png";
import att from "../../images/att.png";
import truist from "../../images/truist.png";
import comcast from "../../images/comcast.png";
import ugh from "../../images/ugh.png";
import bny from "../../images/bny.png"; 
import Bro from '../../images/Brocher1.png';

import './Home.css';

import EastRoundedIcon from '@mui/icons-material/EastRounded';

import { useMediaQuery } from 'react-responsive'

import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import Modal from '@mui/material/Modal';
import { Button,  } from 'semantic-ui-react';



import {
  Pagination,
  Autoplay,

} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import React, { useEffect, useState, useRef } from 'react';


export const Home = () => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 900px)' })
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo(0, 0);
}
  const [width, setWidth] = useState(window.innerWidth);
  const heroRef = useRef<HTMLDivElement | null>(null);
  const backgroundRef = useRef<HTMLDivElement | null>(null);

  const [openB, setOpenB] = React.useState(true);
  const handleOpen = () => setOpenB(true);
  const handleClose = () => setOpenB(false);

  useEffect(() => {
    if (heroRef.current && backgroundRef.current) {
      heroRef.current.style.background = 'none';
      backgroundRef.current.style.backgroundImage = `url(${bgImage2})`;
    }
    const handleScroll = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = maxScaleTop;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.transformOrigin = 'bottom right';
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        backgroundRef.current.style.left = `${(-26.47 * scaleside) + 36.47}%`;
      }
    };
    const handleScrollMobile = () => {
      if (backgroundRef.current) {
        const maxScroll = 630;
        const maxScaleTransform = 1.6;
        const maxScaleTop = 1.68;
        let scale = window.scrollY / 900 + 1;
        let scale1 = Math.max(1.6, scale);
        let scaleTop = window.scrollY / 910 + 1;
        let scaleside = window.scrollY / 910 + 1;
          console.log(window.scrollY );
      
        // if (window.scrollY > maxScroll) {
        //   backgroundRef.current.style.transform = `scale(1.6, 1.6)`;
        //   // backgroundRef.current.style.left = '-5%';
        //   scaleTop = 1.68;
          
        //   // backgroundRef.current.style.top = ``;

        // }
        if (window.scrollY > maxScroll) { 
          scale1= maxScaleTransform;
   
          scaleside = maxScaleTop ;
          scaleTop = 1.8;
   

        }
        // if (window.scrollY > 750) { 
        //   scale1= maxScaleTransform;
   
        //   // scaleside = -(scaleside - 1) ;
        //   backgroundRef.current.style.left = `${(26.47 * scaleside) + 36.47}%`;
   

        // }
      

        // backgroundRef.current.style.transform = `scale(${scale1 }, ${scale1 })`;
        // backgroundRef.current.style.txransformOrigin = 'bottom right';
        // backgroundRef.current.style.top = `${(-22.05 * scaleTop) + 47}%`;
        backgroundRef.current.style.bottom = `-${(scaleTop - 1) *100}%`;
        backgroundRef.current.style.left = `${(-30.47 * scaleside) + 26.47}%`;
      }
    };
    const updateScrollHandler = () => {
      const isMobile = window.innerWidth <= 900; // Adjust breakpoint as needed
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
  
      if (isMobile) {
        window.addEventListener('scroll', handleScrollMobile);
      } else {
        window.addEventListener('scroll', handleScroll);
      }
    };
  
    // Set the initial scroll handler
    updateScrollHandler();
     // Update the scroll handler on resize
  window.addEventListener('resize', updateScrollHandler);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollMobile);
      window.removeEventListener('resize', updateScrollHandler);
    };
}, []);





  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div id="wrapper">

<Modal
        open={openB}
        onClose={handleClose}
        >

<div className='modal'
        // sx={style}
        >
          <div 
          style={{
            display:"flex",
            paddingLeft:'20px',
            alignSelf:'center',
            // backgroundColor:'red',
            justifyContent:'flex-end',
            alignContent:'flex-end',
            alignItems:'flex-end'}}
          > 
          <Button onClick={handleClose} 
          style={{
            backgroundColor:'#98ced5',
          color:'#ffffff',
          height:'50px',
          fontSize:'20px',
          padding:'20px',     
          borderRadius:'10px',
          // display: 'flex',
          paddingBottom: '40px',
          alignSelf:'center',
          justifyContent:'center',
            alignContent:'center',
            alignItems:'center'
          }} >Close</Button>
          </div>
       
        <div className='modal_div'>
        <img  className="imgB" src={Bro} alt="" />
        </div>
        
          
        </div>
        </Modal>
    <section id='hero' ref={heroRef} className="hero"
    // style={{ backgroundImage: `url(${bgImage2})`, backgroundSize: 'auto', background: 'cover' }}
    >
              <div   className='glow_2'></div>

      <div ref={backgroundRef} className="background22">
      <div   ref={backgroundRef}className='glow'></div>
      </div>
      <div className="background2"></div>
      <div className='hero__flex'  >
      <div className='hero__left'  >
        <div>
      <div className='rightbox_paragraph'>
     Great Talent<br></br>
     Perfect Fit

      
            </div>
            
         
            </div>
            
         </div>
         <div className='hero__right'  >
        <div className='right_in' >
          <div className='imgDiv'>
            <img src={heroImg}  className='heroImage'  />
          </div>
          <div className='content_in'>
          <div className='para' >
            <a>
            Connecting top talent with the right opportunities –
      Because reat teams build great businesses.
            </a>
      
            </div>
            
            <div className='button_container'>
      
            <div className='button'    onClick={() =>{ navigate('/contact')
          scrollToTop()}}
         > 
            <div className='button_line'></div>
          <div className='button_text'>
          Hire Top Talent
          <EastRoundedIcon className='arrow' ></EastRoundedIcon>
            </div>
        
         
          </div>
          
      
          <div className='button' onClick={() =>{ navigate('/contact')
          scrollToTop()}}  
          > 
             <div className='button_line'></div>
          <div className='button_text'>
          Find Your Next Job
          <EastRoundedIcon className='arrow' ></EastRoundedIcon>
            </div>
        
         
          </div>
          
            </div>
          </div>
    
        
            </div>
            
         </div>
        
       
      
      </div>
    </section>
    <div className='section2' >
      <div className='left'>
            {/* <a>GET TO KNOW US</a> */}
            <h1>Services</h1>
            <a>-Intell<img src={e} className='elogo' />Sphere</a>
            <p> We believe that talent is only part of the equation—what truly drives success is a well-prepared, adaptable workforce. That’s why we offer tailored training solutions that bridge the gap between hiring and 
              high performance in today’s fast-paced business landscape.</p>
         
            </div>
      <div className='features'>
      <figure className='animate'>
           <div className='get_box'  onClick={() =>{ navigate('/product')
          scrollToTop()}}>
            <div className='get_box_in'>
            {/* <a>GET TO KNOW US</a> */}
            <h1>Staffing</h1>
            
            <p>
            With a combined industry expertise of over 16+years,we provide
comprehensive staffing solutions which include<br></br>
• Contract Staffing (Temp & Project-Based) <br></br>
• Direct Hire Recruiting<br></br>
• Executive & Niche Talent Search
             </p>
         
            </div>
         
            <div className='count2'
           style={{  backgroundSize: 'cover', background: 'contain' }}
           >
      <img src={staff} className='count2_img' />
            </div>
           </div>
           </figure>
           <figure className='animate'>
           <div className='get_box' style={{display:'flex',flexDirection:(isMobileScreen ? 'column-reverse':'row')}}
            onClick={() =>{ navigate('/development')
            scrollToTop()}}
           >
           <div className='count2'
           style={{  backgroundSize: 'cover', background: 'contain' }}
           >
      <img src={deveop} className='count2_img' />
            </div>
            <div className='get_box_in'>
            {/* <a>GET TO KNOW US</a> */}
            <h1>Development</h1>
            <p> 
            We go beyond development, offering strategic guidance and technical expertise to
elevate your business through<br></br>
• Custom Application Development<br></br>
• Enterprise Software Solutions<br></br>
• Software Integration & Modernization<br></br> </p>
         
            </div>
          
           </div>
           </figure>
           <figure className='animate'>
           <div className='get_box'  onClick={() =>{ navigate('/training')
          scrollToTop()}}>
            <div className='get_box_in'>
            {/* <a>GET TO KNOW US</a> */}
            <h1>Training</h1>
            <p>   
            We offer tailored training solutions that bridge the gap between hiring and high
performance in today’s fast-paced business landscape, believing talent is not just a part
of the equation but a true driving force to achieve a well-prepared, adaptable
workforce.
<br></br></p>
         
            </div>
            <div className='count2'
           style={{  backgroundSize: 'cover', background: 'contain' }}
           >
      <img src={train} className='count2_img' />
            </div>
           </div>
           </figure>
           </div>
    </div>
    <div className='section3_h' id='aboutUs'>
      <div className='left3'>  
      <a>Know </a>
            <h1 className='animate'>How We Make <br></br>a Difference</h1> 
            <a className='animate'>Changing People For The Better</a>
            <p className='animate'>IntelleSphere LLC is a trusted name in the USA IT Staffing industry, 
              committed to connecting top-tier technology talent with leading 
              enterprises across the country. With a focused approach and deep 
              industry knowledge, we specialize in providing highly skilled 
              professionals in Java Full Stack Development, Python Development, 
              Machine Learning & AI Engineering, and Cybersecurity.</p>
              
              <div className='button2'  
            onClick={() =>{ navigate('/about-us')
            scrollToTop()}}
            // to ='#hero'
          // onClick={() => {
          //     navigate("/contact");
          //       scrollToTop();
          //   }}
            > 
             <div className='button_line'></div>
          <div className='button_text2'>
          know More
          <EastRoundedIcon className='arrow' ></EastRoundedIcon>
            </div>


          </div>
            </div>

            <div className='right3_h'>  
            <div className='right3_in animate'>
            <img src={gif} className='logoIS' />

              </div>
            
             </div>
           
          
    </div>
    <div className='section4'>

    
            <div className='center2 animate'>
            <img src={gif} className='logoIS' />

              
            
             </div>
   
            <div className='colab_box1'  >
         
            <h1>Hello! We're launching an exciting new project and 
              are looking for the right organization to collaborate with</h1>
           
            {/* <a>Could that be yours?</a> */}
            <div className='button2'  
            onClick={() =>{ navigate('/contact')
            scrollToTop()}}
            // to ='#hero'
          // onClick={() => {
          //     navigate("/contact");
          //       scrollToTop();
          //   }}
            > 
             <div className='button_line'></div>
          <div className='button_text2'>
          know More
          <EastRoundedIcon className='arrow' ></EastRoundedIcon>
            </div>


          </div>
        </div>


      </div>
      <section className="second-section2" >
      <div className="second-section__rightui">
        <div>
          <h1 className='title'>A Proven Track Record</h1>
          {/* <p className='description1'> At OptimumP, we offer good quality 
        <strong>Battery Management System (BMS)</strong>.
         The Battery Management System (BMS) we offer are manufactured under strict quality 
         controls and all the BMS go through high standard Quality Contol before reaching to Indian Market.</p> */}
          <p>
         IntelleSphere Has Worked Exclusively With Established 
Global Brands .
          </p>
        </div>
        {/* <div className='description-button'>
          <Button primary><a href='/product' style={{color: "white"}}>Learn More</a></Button>
        </div> */}
        <div style={{height:200,width:'100%',marginTop:50,}}>
            <Swiper
        className='swiper'
        slidesPerView={isMobileScreen ? 2 : 5}
     
          loop={true}
          centeredSlides={true}
          spaceBetween={0}
          
          grabCursor={true}
          pagination={{
            clickable: true,
          }}
          speed={2000}
          modules={[Autoplay,Pagination]}
          autoplay={{
            reverseDirection:true
          }}
        >
          
          <SwiperSlide className="slide1" >
            <img  className="img3" src={ugh}  />
          </SwiperSlide>
          <SwiperSlide className="slide1" >
            <img  className="img3" src={truist}  />
          </SwiperSlide>
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={fmac}  />
          </SwiperSlide>
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={jpmc}  />
          </SwiperSlide>
         
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={walmart}  />
          </SwiperSlide>
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={bny}  />
          </SwiperSlide>
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={att}  />
          </SwiperSlide>
          <SwiperSlide className="slide1"  >
            <img  className="img3" src={comcast}  />
          </SwiperSlide>

          
        </Swiper>
</div>

     
      
       
      </div>
      {/* <div className="second-section__left">
        <img src={logo} alt='Qshikshak' className='icon' />
      </div> */}


    </section>
          
    </div>
    
    
    
  )
}




